<template>
  <div class="title-row">
    <img class="title-img-left" src="@/assets/member/heng_right.png" alt="">
    <div>
      <slot></slot>
    </div>
    <img class="title-img-right" src="@/assets/member/heng_right.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'RowTitle',
}
</script>

<style lang="less" scoped>
.title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  img {
    width: 125px;
    height: 26px;
  }
  .title-img-left {
    transform: rotate(180deg);
  }
}


</style>
